<div class="terms-dialog" dir="rtl">
  <header class="terms-dialog__header">
    <span class="terms-dialog__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm0 2.5L17.5 8H14V4.5zM8 12h8v1.6H8V12zm0 3.4h8V17H8v-1.6zm0-6.8h4v1.6H8V8.6z"/></svg>
    </span>
    <div class="terms-dialog__heading">
      <h2 class="terms-dialog__title">{{ terms?.title || 'תקנון האתר' }}</h2>
      <p class="terms-dialog__subtitle">
        @if (terms?.version) { גרסה {{ terms?.version }} · }
        נא לקרוא עד הסוף כדי לאשר
      </p>
    </div>
    <button type="button" class="terms-dialog__close" aria-label="סגירה" (click)="close()">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.71 12 12l6.3 6.29-1.42 1.42L10.59 13.4l-6.3 6.3-1.41-1.42L9.17 12l-6.3-6.29L4.3 4.29l6.29 6.3 6.3-6.3z"/></svg>
    </button>
  </header>

  <!-- Reading progress: fills as the user scrolls through the terms. -->
  <div class="terms-dialog__progress" role="progressbar" [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
    <span [style.width.%]="progress"></span>
  </div>

  <div class="terms-dialog__body" #termsBody (scroll)="onScroll()" tabindex="0">
    @if (loading) {
      <div class="terms-dialog__status">
        <span class="terms-dialog__spinner" aria-hidden="true"></span>
        טוען את התקנון...
      </div>
    } @else if (loadError) {
      <p class="terms-dialog__status terms-dialog__status--error">לא הצלחנו לטעון את התקנון. נסו שוב מאוחר יותר.</p>
    } @else {
      <article class="terms-dialog__content" [innerHTML]="terms?.content"></article>
    }
  </div>

  <footer class="terms-dialog__footer">
    <div class="terms-dialog__state" [class.terms-dialog__state--done]="readToEnd">
      @if (readToEnd) {
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4z"/></svg>
        קראת את כל התקנון — אפשר לאשר
      } @else if (!loading && !loadError) {
        <span>נקראו {{ progress }}% מהתקנון</span>
        <button type="button" class="terms-dialog__link" (click)="scrollToEnd()">דלג לסוף ↓</button>
      }
    </div>
    <div class="terms-dialog__actions">
      <button type="button" class="terms-dialog__btn terms-dialog__btn--secondary" (click)="close()">סגירה</button>
      <button type="button" class="terms-dialog__btn" [disabled]="!readToEnd" (click)="accept()">
        קראתי ואני מאשר/ת את התקנון
      </button>
    </div>
  </footer>
</div>
